import { buildInteractiveResult, Result, SearchEngine } from "@coveo/headless";
import { ReactNode, useEffect } from "react";

type InteractiveResultProps = {
	analytics: Record<string, string>;
	ariaLabel?: string;
	attribs: Record<string, string>;
	children: ReactNode;
	downloadUrl?: string;
	headlessEngine: SearchEngine;
	result: Result;
	type: "anchor" | "button";
	onClick?: Function;
};

export const InteractiveResult = ({
	analytics,
	attribs,
	ariaLabel,
	children,
	downloadUrl,
	headlessEngine,
	result,
	type,
	onClick
}: InteractiveResultProps) => {
	const controller = buildInteractiveResult(headlessEngine, {
		options: { result }
	});

	useEffect(() => () => controller.cancelPendingSelect());

	if (type === "anchor") {
		return (
			<a
				aria-label={ariaLabel ?? result.title}
				{...analytics}
				{...attribs}
				href={downloadUrl ?? filterProtocol(result.clickUri)}
				onClick={() => controller.select()}
				onContextMenu={() => controller.select()}
				onMouseDown={() => controller.select()}
				onMouseUp={() => controller.select()}
				onTouchStart={() => controller.beginDelayedSelect()}
				onTouchEnd={() => controller.cancelPendingSelect()}
			>
				{children}
			</a>
		);
	}
	if (type === "button") {
		return (
			<button
				aria-label={ariaLabel ?? result.title}
				{...analytics}
				{...attribs}
				onClick={() => {
					controller.select();
					if (onClick) onClick();
				}}
				onContextMenu={() => controller.select()}
				onMouseDown={() => controller.select()}
				onMouseUp={() => controller.select()}
				onTouchStart={() => controller.beginDelayedSelect()}
				onTouchEnd={() => controller.cancelPendingSelect()}
			>
				{children}
			</button>
		);
	}
	return null;
};

// Filters out dangerous URIs that can create XSS attacks such as `javascript:`.
function filterProtocol(uri: string) {
	const isAbsolute = /^(https?|ftp|file|mailto|tel):/i.test(uri);
	const isRelative = /^\//.test(uri);

	return isAbsolute || isRelative ? uri : "";
}
